import { useSearchPageQuery } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/__internal__/useSearchPageQuery";

export const useSearchPageQuerySpellCheckResponse = () => {
  return useSearchPageQuery().data?.query_spell_check_response;
};
